import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserRoles } from '../../../hooks/useUserRole';
import FullPageLoader from '../FullPageLoader';
import logger from '../../../helpers/logger';
import { hasPageAccess } from '../../../helpers/check-role-permission';
import NoAuthAccess from '../NoAuthAccess';

/**
 * ProtectedRoute Component
 * 
 * Wraps routes to enforce role-based access control.
 * Redirects unauthorized users to home page.
 */
const ProtectedRoute = ({ children, requiredRoles, path }) => {
  const { roles, isLoading } = useUserRoles();
  const location = useLocation();

  if (isLoading) {
    return <FullPageLoader />;
  }

  // Check page access based on path
  const hasAccess = path ? hasPageAccess(roles, path) : 
                    requiredRoles ? roles.some(role => requiredRoles.includes(role)) : true;
  
  if (!hasAccess) {
    logger.warn(`Unauthorized access attempt to ${path || location.pathname} by user with roles: ${roles.join(', ')}`);
    
    return <NoAuthAccess requestedPath={path} />;
  }

  return children;
};

export default ProtectedRoute;